module.exports = __webpack_public_path__ + "img/LDSJ_STILL25.1d572f9a.jpg";